import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getCommodityDataAsync } from 'src/services/costModelling/shouldCostLibrary.services'
import { getCommodityUomConversionRatesAsync } from 'src/services/costModelling/skuShouldCostWorkbench.services'
const initialState = {
  commodityDataLoader: false,
  commodityData: [],
  commodityLastUpdatedDate: '',
  commodityDataError: '',
  commodityUomConversionRate: [],
}

export const getCommodityDataSlice = createSlice({
  name: 'get-commodity-data',
  initialState,
  reducers: {
    resetCommodityData: () => initialState,

    setCommodityData: (state, action) => {
      state.commodityData = action.payload
      state.commodityDataLoader = false
    },

    setCommodityUomConversionRate: (state, action) => {
      state.commodityUomConversionRate = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getCommodityDataAsync.pending), (state) => {
      state.commodityDataLoader = true
    })
    builder.addMatcher(isAnyOf(getCommodityDataAsync.fulfilled), (state, action) => {
      state.commodityDataLoader = false
      state.commodityData = action.payload.data
      state.commodityLastUpdatedDate = action.payload.last_updated_date
    })
    builder.addMatcher(isAnyOf(getCommodityDataAsync.rejected), (state, action) => {
      state.commodityDataLoader = false
      state.commodityDataError = action.payload.message
    })
    builder.addMatcher(isAnyOf(getCommodityUomConversionRatesAsync.fulfilled), (state, action) => {
      state.commodityUomConversionRate = action.payload.data || []
    })
  },
})

export const { resetCommodityData, setCommodityData, setCommodityUomConversionRate } =
  getCommodityDataSlice.actions
export default getCommodityDataSlice.reducer
